<template>
    <el-pagination v-bind="$attrs" v-on="inputListeners"></el-pagination>
</template>
<script>
export default {
    name: "HrrSearchformData",
    props: {
        getform: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            formData: {},
            formDataNew: {}
        };
    },
    watch: {
        // getform: function (newformData, oldformData) {
        //   console.log(newformData,oldformData);
        // }
        getform: {
            //深度监听，可监听到对象、数组的变化
            handler(val, oldVal) {
                for (var i in val) {
                    this.formDataNew[i] = val[i];
                }
                delete this.formDataNew.pageNum;
                delete this.formDataNew.pageSize;
                delete this.formDataNew.__ob__;
                //console.log(this.formDataNew); //但是这两个值打印出来却都是一样的
            },
            deep: true
        }
    },
    methods: {
        formDataform() {
            for (var i in this.getform) {
                this.formData[i] = this.getform[i];
            }
            delete this.formData.pageNum;
            delete this.formData.pageSize;
            delete this.formData.__ob__;
        },
        formDataformtwo() {
            for (var i in this.getform) {
                this.formDataNew[i] = this.getform[i];
            }
            delete this.formDataNew.pageNum;
            delete this.formDataNew.pageSize;
            delete this.formDataNew.__ob__;
        }
    },
    computed: {
        inputListeners: function() {
            var vm = this;
            // `Object.assign` 将所有的对象合并为一个新对象
            return Object.assign({},
                // 我们从父级添加所有的监听器
                this.$listeners,
                // 然后我们添加自定义监听器，
                // 或覆写一些监听器的行为
                {
                    // 这里确保组件配合 `v-model` 的工作
                    "size-change": function(event) {
                        vm.$emit("size-change", event);
                    },
                    "current-change": function(event) {
                        console.log(vm.formDataNew);
                        console.log(vm.formData);

                        function isObjEqual(o1, o2) {
                            var props1 = Object.getOwnPropertyNames(o1);
                            var props2 = Object.getOwnPropertyNames(o2);
                            if (props1.length != props2.length) {
                                //console.log(props2);
                                return false;
                            }
                            for (var i = 0, max = props1.length; i < max; i++) {
                                var propName = props1[i];
                                console.log(propName);
                                if (o1[propName] !== o2[propName]) {
                                    console.log(o1[propName], o2[propName]);
                                    return false;
                                }
                            }
                            return true;
                        }
                        if (isObjEqual(vm.formData, vm.formDataNew) == true) {
                            vm.$emit("current-change", event);
                        } else {
                            vm.$emit("current-change", 1);
                            for (var i in vm.formDataNew) {
                                vm.formData[i] = vm.formDataNew[i];
                            }
                        }
                    }
                }
            );
        }
    },
    created() {
        this.formDataform();
        this.formDataformtwo();
    }
};
</script>
<style>
</style>